const stopPropagation = (event: any) => {
  if (event) {
    event?.stopPropagation();
  }
};
export default stopPropagation;
